import Service from "../../Services";
import { url } from "../../util/Constants";

const ServicesArea = {
  namespaced: true,
  state: {
    form: {
      branch_id: "",
      floor_id: "",
      name_th: "",
      name_en: "",
      description_en: "",
      description_th: "",
      images: "",
      images_show: "",
      access_type_id: "",
      slug_url: "",
      is_publish: true,
      slide_images : [],
    }
  },
  mutations: {
    GET_FORM_SERVICE_AREA: (state, res) => {
      state.form = res;
      if (res.images) {
        state.form.images_show = url + res.images;
      }
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        branch_id: "",
        floor_id: "",
        name_th: "",
        name_en: "",
        description_en: "",
        description_th: "",
        images: "",
        images_show: "",
        access_type_id: "",
        slug_url: "",
        is_publish: true,
        slide_images : [],
      };
    },
    SET_SLIDE_IMAGE: (state, data) => {
      state.form.slide_images = [
        ...state.form.slide_images,
        {
          ...data
        }
      ];
    },
    REMOVE_SLIDE_IMAGE: (state, index) => {
      state.form.slide_images = state.form.slide_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getServiceArea({ commit }, page) {
      return Service.ServiceAreaAPI.getServiceArea(page);
    },
    // eslint-disable-next-line no-unused-vars
    showServiceArea({ commit }, id) {
      return Service.ServiceAreaAPI.showServiceArea(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveServiceArea({ commit }, { id, data }) {
      if (id) {
        return Service.ServiceAreaAPI.updateServiceArea(id, data);
      } else {
        return Service.ServiceAreaAPI.createServiceArea(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteServiceArea({ commit }, id) {
      return Service.ServiceAreaAPI.deleteServiceArea(id);
    },
    setFormServiceArea({ commit }, res) {
      commit("GET_FORM_SERVICE_AREA", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    addImage({commit},data){
      commit('SET_SLIDE_IMAGE',data)
    },
    removeImage({commit},index){
      commit('REMOVE_SLIDE_IMAGE',index);
    }
  }
};
export default ServicesArea;
